module.exports = __webpack_public_path__ + "474b9b82d253e73d60740e5b0a7fb8b7.jpg";